import { ReactElement } from 'react';

import { useFormController } from '@dreryk/react-common';
import { ActionInput, StyledFlex } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

import { ConsentsAndAuthorizationsDocumentsActionFormBean } from './ConsentsAndAuthorizationsDocumentsActionForm.types';
import { ConsentsAndAuthorizationsDocumentsTable } from './table/ConsentsAndAuthorizationsDocumentsTable';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.modal.form;

type ConsentsAndAuthorizationsDocumentsActionFormProps = {
   readonly onApproveAndPrint: VoidFunction;
   readonly patientId: number;
};

export const ConsentsAndAuthorizationsDocumentsActionForm = (
   props: ConsentsAndAuthorizationsDocumentsActionFormProps
): ReactElement => {
   const { register, watch } = useFormController<ConsentsAndAuthorizationsDocumentsActionFormBean>({
      searchText: null,
   });

   const searchText = watch('searchText');

   return (
      <StyledFlex as={'form'} gap={18} direction={'column'} noValidate autoComplete={'off'}>
         <ActionInput
            controller={register('searchText')}
            testId={'searchText'}
            placeholder={t.actionInput.placeholder}
            autoFocus
         />

         <ConsentsAndAuthorizationsDocumentsTable
            onApproveAndPrint={props.onApproveAndPrint}
            patientId={props.patientId}
            searchText={searchText}
         />
      </StyledFlex>
   );
};
